module.exports = __webpack_public_path__ + "static/img/jchb1-5.23d0db7.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-5.png
// module id = 763
// module chunks = 0